import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import DuplicarOrcamento from "../../controls_comp/control-duplicarorcamento";

const ModalDuplicarOrcamento = (props) => {

    const [modal, setModdal] = useState(false);
    const {toggle, className} = props;

    useEffect(() => {
        setModdal(props.modal);
    }, [props.modal])

    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={modal}
            onHide={toggle}
            backdrop="static"
            keyboard={false}
            className={className}>
            <ModalHeader toggle={toggle} closeButton></ModalHeader>
            <ModalBody>
                <DuplicarOrcamento {...props} />
            </ModalBody>
        </Modal>
    )
}

export default ModalDuplicarOrcamento;
